import store from '../store/store'
import router from '@/router/index'

function formtRouter(route) {
    if (route.component.indexOf('*') !== -1) return false;
    let url = route.component.slice(7, route.component.length);
    route.component = () =>
        import (`@/page/${url}`);
    route.name = route.meta.title;
    route.meta.btnperm = route.btnperm;
    //   没有子路由
    if (!route.children) {
        router.addRoute(route);
    } else {
        //   至少一个子路由
        let routeChild = route.children;
        route.children = null; //设置为null防止添加到router时解析为格式化的子路由
        router.addRoute(route);
        //循环子路由继续调用
        routeChild.forEach(item => {
            formtRouter(item)
        })

    }
}


function accessRoutes(data) {
    localStorage.setItem('routes', JSON.stringify(data));
    //   深拷贝防止循环时修改
    store.commit('routers', JSON.parse(JSON.stringify(data)));
    //   遍历路由并格式化添加到router
    data.forEach(item => {
        formtRouter(item);
    });
}

async function dynamicRouters(isGoHome = false) {
    // 请求个人信息
    await store.dispatch('requestUserInfo', isGoHome);

    // 请求路由
    let routerJurisdiction = await store.dispatch('routers');

    if (!routerJurisdiction) return false;
    accessRoutes((routerJurisdiction.data && routerJurisdiction.data.routes) || routerJurisdiction);
}

export default dynamicRouters;


// WEBPACK FOOTER //
// ./src/utils/router.js